export default "__VITE_ASSET__Czsat0wD__"